import { Container, Flex, Grid, GridItem, Image, Link } from "@chakra-ui/react"
import { Outlet, createFileRoute } from "@tanstack/react-router"
import Sidebar from "../components/UI/sidebar"
import Header from "../components/UI/header"
import Footer from "../components/UI/footer"
import { Helmet } from "react-helmet-async"
import { useSettings } from "../components/UI/settings-context"

import jakob from "../../public/assets/images/jakobmarkt-inserat.jpg"

export const Route = createFileRoute("/_layout")({
  component: Layout,
})

function Layout() {
  const policy = useSettings()?.policy

  return (
    <>
      <Helmet>
        <title>{policy?.website_title ?? "Hermes - Paper"}</title>
        <meta name="description" content={policy?.website_description ?? "Hermes Zeitungs System"} />

        <meta property="og:title" content={policy?.website_title ?? "Hermes - Paper"} />
        {policy?.website_description &&
            <meta property="og:description" content={policy.website_description} />
        }
        <meta property="og:url" content={policy?.website_domain ?? "wochen-zeitung.ch"} />
        <meta property="og:type" content="website" />
      </Helmet>

      <Header />

      <Grid minW="full" minH="62vh" mt={20} templateColumns={{ base: "1fr", md: "1fr 3fr 1fr" }} gap={4}>
        <GridItem hideBelow="md">
          <Container m={0}>
            <Sidebar />
          </Container>
        </GridItem>

        <GridItem>
          <Outlet />
        </GridItem>

        <GridItem alignItems="center"  hideBelow="md">
          <Flex direction="column" alignItems="center" gapY={10}>
            <Link href="https://www.jakob-markt.ch/jakob-schuehparadies.html" target="_blank" w={{ base: "80%", "2xl": "60%" }} cursor="pointer"><Image src={jakob} alt="Jakob's Schuehparadies" /></Link>
          </Flex>
        </GridItem>
      </Grid>

      <Footer />
    </>
  )
}
